<template>
  <div
    ref="noti"
    v-touch:swipe.right="swipeXHandler"
    v-touch:swipe.left="swipeXHandler"
    v-touch:swipe.top="swipeTopHandler"
    v-touch:swipe.bottom="swipeBottomHandler"
    id="dropdown-notification"
  >
    <div class="icon-section" v-if="icon">
      <img class="img" :src="`/static/icons/${icon}-icon.svg`" />
    </div>
    <div class="content-section">
      <div class="title" v-html="$t(title)"></div>
      <div class="text" v-html="$t(text)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownNofication",
  props: {
    duration: {
      type: Number,
      required: false,
      default: 3500
    },
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    action: {
      type: Function,
      required: false
    }
  },
  mounted() {
    if (this.icon === "error") {
      this.playErrorSound();
    } else if (this.icon === "success") {
      this.playSuccessSound();
    }
    setTimeout(() => {
      this.swipeTopHandler();
    }, this.duration);
  },
  methods: {
    playErrorSound() {
      const audio = new Audio(require("@/assets/sounds/error.wav"));
      audio.play();
    },
    playSuccessSound() {
      const audio = new Audio(require("@/assets/sounds/success.wav"));
      audio.play();
    },
    swipeTopHandler() {
      const vm = this;
      this.$anime.timeline().add({
        targets: this.$refs["noti"],
        translateY: -150,
        opacity: 0,
        easing: "easeOutExpo",
        complete: function() {
          vm.$eventBus.closeDropdownNoti();
        }
      });
    },
    swipeXHandler(data) {
      const side = data === "right" ? "100vw" : "-100vw";
      const vm = this;
      this.$anime.timeline().add({
        targets: this.$refs["noti"],
        translateX: side,
        duration: 1750,
        opacity: 0,
        easing: "easeOutExpo",
        complete: function() {
          vm.$eventBus.closeDropdownNoti();
        }
      });
    },
    swipeBottomHandler() {
      const vm = this;
      this.$anime.timeline().add({
        targets: this.$refs["noti"],
        translateY: "50px",
        opacity: 0,
        easing: "easeOutExpo",
        complete: () => {
          vm.$eventBus.closeDropdownNoti();
          if (this.action) {
            this.action();
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#dropdown-notification {
  @import "~@/styles/variables.scss";
  width: 500px;
  min-height: 85px;
  max-width: 90vw;
  background-color: white;
  border-radius: 20px;
  border-radius: 8px;
  box-shadow: 0px 5px 10px 4px #00000029;
  position: fixed;
  top: 20px;
  right: 0;
  left: 0;
  margin: auto;
  z-index: $Z-dropdown-noti;
  display: flex;
  .icon-section {
    height: 100%;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    .img {
      width: 50px;
      height: 50px;
    }
  }
  .content-section {
    display: flex;
    flex-grow: 1;
    height: auto;
    display: flex;
    flex-direction: column;
    .title {
      height: 35px;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      padding-left: 10px;
      padding-right: 10px;
    }
    .text {
      font-size: 15px;
      text-align: center;
      padding: 2px 10px 10px 10px;
    }
  }
}
</style>
